import React, { useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  CircularProgress,
  Checkbox,
  Typography,
  Fade,
  Zoom,
} from "@mui/material";
// import axios from "axios"; // Commented out - was used for captcha verification
import { styled } from "@mui/material/styles";
import logo from "../../../assets/img/Fronic_Logo_white.png";
import { useHistory } from "react-router-dom";
// import ReCAPTCHA from "react-google-recaptcha"; // Commented out - using IP validation instead
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import HomeIcon from "@mui/icons-material/Home";
import LockIcon from "@mui/icons-material/Lock";
import { toastError, toastSuccess } from "../../../utils";
import { ChristmasHat, NewYearMagic } from "../../../components/Festival"; // Festival Theme - Auto-enabled based on date
import { getFestivalTheme } from "../../../utils/festivalThemes";

const StyledButton = styled(Button)({
  fontFamily: "'DM Sans', sans-serif",
  background: "linear-gradient(135deg, #1a73e8 0%, #00bfa5 100%)",
  fontSize: 16,
  height: 50,
  fontWeight: 600,
  textTransform: "none",
  borderRadius: "12px",
  boxShadow: "0 4px 20px rgba(26, 115, 232, 0.3)",
  transition: "all 0.3s ease",
  "&:hover": {
    background: "linear-gradient(135deg, #1557b0 0%, #00a589 100%)",
    transform: "translateY(-2px)",
    boxShadow: "0 6px 25px rgba(26, 115, 232, 0.4)",
  },
  "&:disabled": {
    background: "#555",
    color: "#999",
  },
});

const CssTextField = styled(TextField)({
  fontFamily: "'DM Sans', sans-serif",
  "& label": {
    fontFamily: "'DM Sans', sans-serif",
    color: "rgba(255, 255, 255, 0.7)",
  },
  "& label.Mui-focused": {
    color: "#00bfa5",
  },
  "& .MuiOutlinedInput-root": {
    fontFamily: "'DM Sans', sans-serif",
    backgroundColor: "rgba(255, 255, 255, 0.05)",
    backdropFilter: "blur(10px)",
    borderRadius: "12px",
    transition: "all 0.3s ease",
    "& fieldset": {
      borderColor: "rgba(255, 255, 255, 0.2)",
      borderWidth: "2px",
    },
    "&:hover fieldset": {
      borderColor: "rgba(255, 255, 255, 0.3)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#00bfa5",
      borderWidth: "2px",
    },
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
    },
  },
  "& .MuiOutlinedInput-input": {
    color: "white",
    padding: "16px 14px",
  },
});

function Signup(props) {
  const history = useHistory();
  const [checked, setChecked] = useState(false);
  const [emailChecked, setEmailChecked] = useState(false);
  // const [isCapchaGood, setIsCapchaGood] = useState(false);
  const isCapchaGood = true; // Captcha disabled - using IP validation instead
  const [festivalTheme] = useState(getFestivalTheme()); // Get theme once on mount

  //---capcha code starts-------------------------- (Commented out - using IP validation instead)

  // async function onChangeCapcha(value) {
  //   await axios
  //     .post(
  //       `https://backend.fronicmedia.com/api/capchaVerification?responseCapcha=${value}`
  //     )
  //     .then((res) => {
  //       if (res?.data?.body?.success === false) {
  //         setIsCapchaGood(false);
  //         toastError("Captcha expired. Try again ?");
  //       } else if (res?.data?.body?.success === true) {
  //         setIsCapchaGood(true);
  //         toastSuccess("Good to see you Human.");
  //       } else {
  //         toastError("Captcha verification failed.");
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }

  //---code ends-----------------------------------

  const {
    onChangeHandler,
    user,
    errors,
    showPassword,
    setShowPassword,
    onSignup,
    loginLoader,
    refCustomer,
  } = props;

  return (
    <Fade in timeout={800}>
      <div className="login-div" style={{ position: "relative" }}>
        {/* Festival Themes - Auto-enabled based on date */}
        {festivalTheme === "christmas" && <ChristmasHat />}
        {festivalTheme === "newyear" && <NewYearMagic />}
        <Grid container spacing={0}>
          {refCustomer ? (
            <Grid item xs={12}>
              <Fade in timeout={1200}>
                <div className="welcome-by-ref">
                  <Typography
                    variant="h4"
                    sx={{
                      textAlign: "center",
                      color: "white",
                      fontWeight: 700,
                      fontFamily: "'DM Sans', sans-serif",
                      background: "linear-gradient(135deg, #00bfa5 0%, #1a73e8 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                      mb: 2,
                      animation: "slideInDown 0.8s ease-out",
                      "@keyframes slideInDown": {
                        "0%": {
                          opacity: 0,
                          transform: "translateY(-30px)",
                        },
                        "100%": {
                          opacity: 1,
                          transform: "translateY(0)",
                        },
                      },
                    }}
                  >
                    Welcome, <Box component="span" sx={{ fontWeight: 800 }}>{refCustomer}</Box>
                  </Typography>
                </div>
              </Fade>
            </Grid>
          ) : null}

          <Grid item xs={12}>
            <Zoom in timeout={600}>
              <div className="logo-image-div">
                <img src={logo} alt="Fronic Media" />
              </div>
            </Zoom>
          </Grid>

          <Grid item xs={12}>
            <Box mt={2} mb={0.5}>
              <Fade in timeout={1000}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1.5,
                    mb: 2,
                    fontFamily: "'DM Sans', sans-serif",
                  }}
                >
                  <span style={{ fontSize: "1.4rem", fontWeight: 700, color: "white" }}>
                    Create Account
                  </span>
                  <span style={{ fontSize: "1rem", fontWeight: 300, color: "rgba(255, 255, 255, 0.25)" }}>
                    |
                  </span>
                  <span style={{ fontSize: "0.8rem", fontWeight: 400, color: "rgba(255, 255, 255, 0.5)" }}>
                    Lets get you onboarded
                  </span>
                </Box>
              </Fade>
            </Box>
          </Grid>

        <Grid item xs={12}>
          <Box mb={2}>
            <CssTextField
              label="Name"
              variant="outlined"
              value={user.name}
              error={!!errors.name}
              onChange={(e) => onChangeHandler("name", e)}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PersonIcon sx={{ color: "rgba(255, 255, 255, 0.5)" }} />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Typography
            sx={{
              color: "rgba(255, 255, 255, 0.6)",
              fontSize: "0.75rem",
              textAlign: "center",
              mb: 1.5,
              fontFamily: "'DM Sans', sans-serif",
            }}
          >
            Typing your full name in this box will act as your digital
            signature.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box mb={2}>
            <CssTextField
              label="Email Address"
              variant="outlined"
              value={user.email}
              error={!!errors.email}
              autoComplete="off"
              onChange={(e) => onChangeHandler("email", e)}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailIcon sx={{ color: "rgba(255, 255, 255, 0.5)" }} />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box mb={2}>
            <CssTextField
              type="number"
              label="Phone"
              variant="outlined"
              value={user.phone}
              error={!!errors.phone}
              onChange={(e) => {
                if (e.target.value.toString().length > 10) {
                  return;
                }
                onChangeHandler("phone", e);
              }}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PhoneIcon sx={{ color: "rgba(255, 255, 255, 0.5)" }} />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box mb={2}>
            <CssTextField
              label="Address"
              variant="outlined"
              value={user.address}
              error={!!errors.address}
              autoComplete="off"
              onChange={(e) => onChangeHandler("address", e)}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <HomeIcon sx={{ color: "rgba(255, 255, 255, 0.5)" }} />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box mb={2}>
            <CssTextField
              type={showPassword.first ? "text" : "password"}
              label="Password"
              variant="outlined"
              autoComplete="off"
              value={user.password}
              error={!!errors.password}
              onChange={(e) => onChangeHandler("password", e)}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon sx={{ color: "rgba(255, 255, 255, 0.5)" }} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() =>
                        setShowPassword({
                          ...showPassword,
                          first: !showPassword.first,
                        })
                      }
                      edge="end"
                      sx={{ color: "rgba(255, 255, 255, 0.5)" }}
                    >
                      {showPassword.first ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box display="flex" alignItems="center" mb={1.5}>
            <Checkbox
              sx={{ color: "rgba(255, 255, 255, 0.7)" }}
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
            />
            <Typography
              sx={{
                color: "rgba(255, 255, 255, 0.8)",
                fontSize: "0.8125rem",
                fontFamily: "'DM Sans', sans-serif",
              }}
            >
              I understand and agree to the Fronic Media{" "}
              <a
                className="a-tag-term-conditions"
                href="https://fronicmedia.com/distribution-agreement/"
                target="_blank"
                rel="noreferrer"
              >
                Distribution Terms
              </a>{" "}
              &{" "}
              <a
                className="a-tag-term-conditions"
                href="https://fronicmedia.com/privacy-policy/"
                target="_blank"
                rel="noreferrer"
              >
                Privacy Policy
              </a>
              .
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box display="flex" alignItems="center" mb={1.5}>
            <Checkbox
              sx={{ color: "rgba(255, 255, 255, 0.7)" }}
              checked={emailChecked}
              onChange={(e) => setEmailChecked(e.target.checked)}
            />
            <Typography
              sx={{
                color: "rgba(255, 255, 255, 0.8)",
                fontSize: "0.8125rem",
                fontFamily: "'DM Sans', sans-serif",
              }}
            >
              I consent to receiving marketing communications, service updates, and promotional offers from Fronic Media via email.
            </Typography>
          </Box>
        </Grid>

        {/* Captcha commented out - using IP validation instead */}
        {/* {checked && emailChecked && (
          <Grid item xs={12}>
            <Box mb={2.5} display="flex" justifyContent="center">
              <ReCAPTCHA
                sitekey="6LdUG_gjAAAAAEXj3qkc5X-jlW4Z4JOpqPiopmmm"
                onChange={onChangeCapcha}
                theme="dark"
              />
            </Box>
          </Grid>
        )} */}
        <Grid item xs={12}>
          <Box mb={2}>
            <StyledButton
              variant="contained"
              onClick={
                checked && emailChecked
                  ? onSignup
                  : () => {
                      !checked
                        ? toastError("Please read & accept terms")
                        : toastError("Please accept email updates.");
                    }
              }
              disabled={!(checked && emailChecked) || loginLoader}
              fullWidth
            >
              {loginLoader ? (
                <CircularProgress size={24} style={{ color: "white" }} />
              ) : (
                "Sign Up"
              )}
            </StyledButton>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box textAlign="center">
            <Typography
              className="dont-have-account"
              onClick={() => history.push("/login")}
              sx={{
                cursor: "pointer",
                fontSize: "0.875rem",
                fontWeight: 500,
                transition: "color 0.2s ease",
              }}
            >
              Already have an account?{" "}
              <span
                style={{
                  color: "#00bfa5",
                  fontWeight: 600,
                }}
              >
                Login
              </span>
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </div>
    </Fade>
  );
}

export default Signup;
